import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import config from "../../config";

const transporterOrderSlice = createSlice({
  name: "transporterOrder",

  initialState: {
    transporterOrderData: [],
    isError: false,
  },

  reducers: {
    fetchTransporterOrderSuccess: (state, action) => {
      state.isError = false;
      state.transporterOrderData = action.payload;
    },
    fetchTransporterOrderFailure: (state) => {
      state.isError = true;
    },
    resetTransporterOrder: (state) => {
      state.isError = false;
      state.transporterOrderData = [];
    },
  },
});

export const {
  fetchTransporterOrderSuccess,
  fetchTransporterOrderFailure,
  resetTransporterOrder,
} = transporterOrderSlice.actions;

export const fetchTransporterOrder = (logout) => async (dispatch) => {
  try {
    const response = await axios.get(`${config.apiUrl}/transporter/order`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: config.token,
        Accept: "application/json",
      },
    });

    dispatch(fetchTransporterOrderSuccess(response.data.data));
  } catch (error) {
    dispatch(fetchTransporterOrderFailure());
    if (error.response && error.response.status === 401) {
      logout();
    }
  }
};

export default transporterOrderSlice.reducer;
